import React from 'react';
import { connect } from 'react-redux'
import ListadoParametros from './ListadoParametros';

//Importación de actions.
import {
    getDataListadoParametros,
    resetState,
    findEntidades,
    orderColumn,
    setearEntidad,
    selectComboProducto
} from '../actions/Actions';

const mapStateToProps = (state) => {
    return {
        data: state.listadoParametros.data,
        atlas: state.atlas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getDataListadoParametros: (currentScope) => {
            dispatch(getDataListadoParametros(currentScope));
        },
        orderColumn: (columnName) => {
            dispatch(orderColumn(columnName));
        },
        selectComboProducto: (productoCodigo) => {
            dispatch(selectComboProducto(productoCodigo));
        },
        resetState: () => {
            dispatch(resetState());
        },
        findEntidades: (filtro) => {
            dispatch(findEntidades(filtro));
        },
        setearEntidad: (objEntidad) => {
            dispatch(setearEntidad(objEntidad));
        }
    }
}

const ListadoParametrosContainer = connect(mapStateToProps, mapDispatchToProps)(ListadoParametros);

export default ListadoParametrosContainer;
